/* eslint-disable no-await-in-loop,guard-for-in,no-restricted-syntax */
import React from 'react';
import { connect } from "react-redux";
import { SubmissionError, Field, reduxForm, formValueSelector } from 'redux-form';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import {
  OfficePhoneLabel,
  StepControl,
  FormFileField,
  FormWrapper,
  StepperTitle,
  FieldWrapper
} from '../components';
import scrollToError from '../../../../utils/scrollToError';
import { validateDoc } from '../../../../utils/validators';
import { ONBOARDING_STEPS } from '../../../../constants';
import { user } from '../../../../utils/api';
import DocumentsUploadMethodPicker from "../components/DocumentsUploadMethodPicker";
import InfoAlert from "../components/InfoAlert";

const validFiles = [
  'dealer_bond',
  'dmv_license',
  'resale_certificate',
  'city_business_license'
];

const requiredFile = value => (!value || !value.type ? 'Required' : undefined);

const StyledFormWrapper = styled.form`
  width: 100%;
`;

class fourthBuyerStep extends React.PureComponent {
  state = {
    isLoading: false
  };

  continueOnboarding = onSubmit => async (files) => {
    let index = 0;
    this.setState({
      isLoading: true
    });
    for (const property in files) {
      if (validFiles.indexOf(property) >= 0) {

        const data = {
          [property]: files[property],
        };
        if (index === Object.keys(files).length - 3) {
          data.last_step = ONBOARDING_STEPS.FIFTH_BUYER_STEP;
        }

        try {
          await user.continueOnboarding(data);
          index += 1;
        } catch ({ response }) {
          if (response && response.status === 400) {
            const errors = (response.data.data || []).reduce(
              (acc, error) => ({
                ...acc,
                [error.field]: error.message
              }),
              {}
            );
            // eslint-disable-next-line no-throw-literal
            throw new SubmissionError(errors);
          }
          this.setState({
            isLoading: false
          });
        }
      }
    }

    this.setState({
      isLoading: false
    });
    onSubmit();

  };

  render() {
    const { handleSubmit, nextStep, prevStep, documents_upload_method } = this.props;
    const { isLoading } = this.state;
    return (
      <StyledFormWrapper onSubmit={handleSubmit(this.continueOnboarding(nextStep))}>
        <FormWrapper>
          <StepperTitle title="Documents" subTitle="Step 4 of 5" />
          <Grid container spacing={24} style={{marginBottom: '20px'}}>
            <DocumentsUploadMethodPicker />
          </Grid>

          {documents_upload_method === 'upload' &&
            <Grid container spacing={24}>
              <FieldWrapper>
                <Field
                  name="dmv_license"
                  component={FormFileField}
                  label="DMV Vehicle Dealer License"
                  id="dmv"
                  validate={[requiredFile, validateDoc]}
                  formName="registrationForm"
                />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                  name="resale_certificate"
                  component={FormFileField}
                  label="Sellers Permit"
                  id="resale"
                  validate={[requiredFile, validateDoc]}
                  formName="registrationForm"
                />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                  name="city_business_license"
                  component={FormFileField}
                  label="City Business License"
                  id="city_business"
                  validate={[requiredFile, validateDoc]}
                  formName="registrationForm"
                />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                  name="dealer_bond"
                  component={FormFileField}
                  label="Dealer Bond/Other (Optional)"
                  id="dealer"
                  type="file"
                  validate={validateDoc}
                  formName="registrationForm"
                />
              </FieldWrapper>
            </Grid>
          }
          {documents_upload_method === 'email' &&
            <>
              <br />
              <InfoAlert>
                <span>
                  <span>Send us the following documents at </span>
                  <a href="mailto:info@autoaxess.com">info@autoaxess.com</a>
                </span>
              </InfoAlert>
              <br />
              <ul>
                <li>DMV Vehicle Dealer License</li>
                <li>Sellers Permit</li>
                <li>City Business License</li>
                <li>Dealer Bond/Other (Optional)</li>
              </ul>
            </>
          }
        </FormWrapper>
        <OfficePhoneLabel />
        <StepControl isLoading={isLoading} prevStep={prevStep} />
      </StyledFormWrapper>
    )
  }
};

const documentsForm = reduxForm({
  form: 'registrationForm',
  destroyOnUnmount: false,
  fields: [
    'dealer_bond',
    'dmv_license',
    'resale_certificate',
    'city_business_license'
  ],
  onSubmitFail: scrollToError
})(fourthBuyerStep);

const selector = formValueSelector('registrationForm');

export default connect(state => ({
  documents_upload_method: selector(state, 'documents_upload_method')
}))(documentsForm)
